import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";

import { pages } from "@/root/consts";
import { AuthApi } from "@/api";
import { setAreUsers, setUserType } from "@/store/reducers/user/userSlice";
import { useAppDispatch } from "@/hooks/redux";
import { ErrorAlert, Header, Router } from "@/components";

const App: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { userType } = await AuthApi.me();
        dispatch(setUserType(userType));
      } catch (e) {
        if (e instanceof AxiosError && e.response?.status === 404) {
          dispatch(setAreUsers(false));
          return navigate(pages.createUser.path);
        }
        navigate(pages.login.path);
      }
    })();
  }, [dispatch]);

  return (
    <div>
      <ErrorAlert />
      <Header />
      <div className="pages">
        <Router />
      </div>
    </div>
  );
};

export default App;
